import { defineComponent as _defineComponent } from 'vue'
import { mdiCheck } from '@mdi/js'
// @ts-expect-error ignore
import store from '@/store'
import { eventApi, IEvent } from '@/enitites/event'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router/composables'


export default /*#__PURE__*/_defineComponent({
  __name: 'BKCheckinButton',
  props: {
    event: null
  },
  emits: ["update:event", "checkIn", "purchase"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:event', value: IEvent): void
  (e: 'checkIn'): void
  (e: 'purchase'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  event: IEvent
};



const loading = ref(false)

const getUserDB = computed(() => store.getters.getUserDB)


const router = useRouter()

function redirectUnauthorized() {
  if (getUserDB.value) return
  router.push({ name: 'Signup' })
}

async function checkinUser() {
  redirectUnauthorized()
  loading.value = true
  const updatedEvent = await eventApi.checkinCurrentUser(props.event.id)
  loading.value = false

  if (updatedEvent) {
    emit('checkIn')
    emit('update:event', updatedEvent)
  }
}

return { __sfc: true,props, loading, getUserDB, emit, router, redirectUnauthorized, checkinUser, mdiCheck }
}

})